import useAxios from "axios-hooks";
import { Visualization } from "../components/visualization/Visualization";

import { useMemo } from "react";
import { Breadcrumb } from "../components/layout/Breadcrumb";

const endpoint = window.__env__.BASE_API_URL;

export const VisualizationPage = () => {
  const currUrl = window.location.href;
  const splited = currUrl.split("/");
  const resourceId = splited.pop();
  const resourceName = decodeURIComponent((splited || []).pop() || "");
  const resourceCode = decodeURIComponent((splited || []).pop() || "");
  const [{ data, loading, error }] = useAxios(
    `${endpoint}?resource_id=${resourceId}`
  );

  const { source, dict } = useMemo(() => {
    const fields = data?.result?.fields || [];
    const records = data?.result?.records || [];

    const dict = fields.map((field: any) => {
      return {
        attribute: field.id,
        type: field?.info?.type_override || field.type,
        label: field?.info?.label || "-",
        desc: field?.info?.notes || "-",
      };
    });

    return { source: records, dict };
  }, [data?.result]);

  if (loading) return <div></div>;
  if (error) {
    console.error("error", error);

    return <div>Error!</div>;
  }

  return (
    <>
      <Breadcrumb
        id={resourceId || ""}
        name={resourceName || ""}
        code={resourceCode || ""}
      />
      <Visualization
        dataSource={source}
        dataDict={dict}
        resourceName={resourceName || ""}
      />
    </>
  );
};
